import Repository from './base'

export class KeyValueRepository extends Repository<any> {}
